import get from 'lodash/get';

import { ToastTypeVariants } from '@/hooks/useToast';

import { type ToastErrorMessage } from './typings';

export const defaultErrorToastMessage: ToastErrorMessage = (error) => [ToastTypeVariants.ERROR, error.message];

export const getRoutePath = (originalError: unknown): string | null => {
  // Try to get x-glade-path from response headers
  const gladePath = get(originalError, 'response.headers.x-glade-path');
  if (typeof gladePath === 'string') {
    return gladePath;
  }

  // Try to get responseURL from request
  const responseUrl = get(originalError, 'request.responseURL');
  if (typeof responseUrl === 'string') {
    return responseUrl;
  }

  return null;
};
